import MFL10sDropdownBody from './MFL10sDropdownBody'
export default MFL10sDropdownBody



// WEBPACK FOOTER //
// ./src/molecules/PromoNotifications/components/MFL10sDropdownBody/index.js